type Props = {
  text: string
}
export function RequiredLabel({ text }: Props): React.ReactNode {
  return (
    <>
      {text} <span className="text-red-500 font-bold">*</span>
    </>
  )
}
